import { makeStyles } from '@material-ui/core';
import { getFillColor, LogoProps } from './common';

export const TratonLogo = ({
  applyTheme = false,
  width,
  height,
  maxWidth,
  fillColor,
}: LogoProps) => {
  const classes = makeStyles(theme => ({
    svg: {
      width: width || 448,
      maxWidth: maxWidth || 'auto',
      height: height || 108,
    },
    path: {
      fill: fillColor ? fillColor : getFillColor(theme, applyTheme),
    },
  }))();

  return (
    <svg
      className={classes.svg}
      viewBox="0 0 448 108"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="TRATON Developer Portal"
    >
      <g clipPath="url(#traton-logo-clip)">
        <path
          className={classes.path}
          d="M302.368 58.1829C288.986 58.1829 278.056 47.4143 278.056 34.0691C278.056 20.6579 288.986 9.82324 302.368 9.82324C315.749 9.82324 326.613 20.6579 326.613 34.0691C326.613 47.4143 315.749 58.1829 302.368 58.1829ZM379.873 11.607V59.0418L347.612 30.3034V57.8526H339.001V10.4178L371.195 40.1471V11.607H379.873ZM90.7829 57.8526H81.8399V19.4027H64.6826V11.607H108.006V19.4027H90.7829V57.8526ZM129.867 57.8526H120.99V11.607H146.958C156.299 11.607 163.784 19.3366 163.784 28.9161C163.784 35.3904 160.406 41.3363 155.57 43.8468L162.791 57.8526H152.788L146.494 45.5645H129.867V57.8526ZM182.995 57.8526H172.86L196.376 11.607H206.578L182.995 57.8526ZM254.804 57.8526H245.927V19.4027H228.704V11.607H272.028V19.4027H254.804V57.8526ZM302.368 49.7266C310.979 49.7266 318.067 42.6576 318.067 34.0691C318.067 25.3485 310.979 18.2796 302.368 18.2796C293.69 18.2796 286.668 25.3485 286.668 34.0691C286.668 42.6576 293.69 49.7266 302.368 49.7266ZM129.867 19.4027V37.967H144.838C152.258 37.967 154.974 32.6818 154.974 28.7179C154.974 24.2254 151.264 19.4027 144.838 19.4027H129.867ZM227.578 57.8526H217.177L207.506 38.8258L212.606 28.6518L227.578 57.8526Z"
        />
      </g>
      <path
        className={classes.path}
        d="M448.001 106.745H427.99V78.5037H433.235V102.307H448.001V106.745Z"
      />
      <path
        className={classes.path}
        d="M423.558 106.745H418.071L415.247 100.209H401.126L398.342 106.745H392.936L405.645 78.5037H410.809L423.558 106.745ZM408.186 83.7484L402.901 96.0938H413.512L408.186 83.7484Z"
      />
      <path
        className={classes.path}
        d="M384.212 106.745H378.967V82.9415H369.607V78.5037H393.572V82.9415H384.212V106.745Z"
      />
      <path
        className={classes.path}
        d="M360.913 97.4655L367.408 106.745H361.76L355.991 98.4742C355.628 98.5145 355.265 98.5145 354.901 98.5145H348.527V106.745H343.282V78.5037H354.901C362.325 78.5037 366.924 82.296 366.924 88.5494C366.924 92.8259 364.745 95.9728 360.913 97.4655ZM361.639 88.5494C361.639 84.9991 359.259 82.9415 354.659 82.9415H348.527V94.1976H354.659C359.259 94.1976 361.639 92.0997 361.639 88.5494Z"
      />
      <path
        className={classes.path}
        d="M321.672 107.148C312.918 107.148 306.462 100.975 306.462 92.6241C306.462 84.2728 312.918 78.1001 321.672 78.1001C330.427 78.1001 336.882 84.2325 336.882 92.6241C336.882 101.016 330.427 107.148 321.672 107.148ZM321.672 102.549C327.361 102.549 331.597 98.3933 331.597 92.6241C331.597 86.8548 327.361 82.6994 321.672 82.6994C315.984 82.6994 311.748 86.8548 311.748 92.6241C311.748 98.3933 315.984 102.549 321.672 102.549Z"
      />
      <path
        className={classes.path}
        d="M278.366 78.5037H289.985C297.409 78.5037 302.008 82.296 302.008 88.5494C302.008 94.7625 297.409 98.5952 289.985 98.5952H283.611V106.745H278.366V78.5037ZM283.611 94.1573H289.743C294.342 94.1573 296.723 92.0997 296.723 88.5494C296.723 84.9991 294.342 82.9415 289.743 82.9415H283.611V94.1573Z"
      />
      <path
        className={classes.path}
        d="M253.656 97.4655L260.151 106.745H254.503L248.734 98.4742C248.371 98.5145 248.008 98.5145 247.645 98.5145H241.27V106.745H236.025V78.5037H247.645C255.068 78.5037 259.667 82.296 259.667 88.5494C259.667 92.8259 257.489 95.9728 253.656 97.4655ZM254.382 88.5494C254.382 84.9991 252.002 82.9415 247.403 82.9415H241.27V94.1976H247.403C252.002 94.1976 254.382 92.0997 254.382 88.5494Z"
      />
      <path
        className={classes.path}
        d="M213.402 94.5607V102.347H229.338V106.745H208.157V78.5037H228.773V82.9012H213.402V90.2439H227.038V94.5607H213.402Z"
      />
      <path
        className={classes.path}
        d="M178.438 78.5037H190.057C197.48 78.5037 202.079 82.296 202.079 88.5494C202.079 94.7625 197.48 98.5952 190.057 98.5952H183.682V106.745H178.438V78.5037ZM183.682 94.1573H189.815C194.414 94.1573 196.794 92.0997 196.794 88.5494C196.794 84.9991 194.414 82.9415 189.815 82.9415H183.682V94.1573Z"
      />
      <path
        className={classes.path}
        d="M156.828 107.148C148.073 107.148 141.618 100.975 141.618 92.6241C141.618 84.2728 148.073 78.1001 156.828 78.1001C165.582 78.1001 172.037 84.2325 172.037 92.6241C172.037 101.016 165.582 107.148 156.828 107.148ZM156.828 102.549C162.516 102.549 166.752 98.3933 166.752 92.6241C166.752 86.8548 162.516 82.6994 156.828 82.6994C151.139 82.6994 146.903 86.8548 146.903 92.6241C146.903 98.3933 151.139 102.549 156.828 102.549Z"
      />
      <path
        className={classes.path}
        d="M139.166 106.745H119.155V78.5037H124.4V102.307H139.166V106.745Z"
      />
      <path
        className={classes.path}
        d="M96.5319 94.5607V102.347H112.468V106.745H91.2871V78.5037H111.903V82.9012H96.5319V90.2439H110.168V94.5607H96.5319Z"
      />
      <path
        className={classes.path}
        d="M72.7409 100.29L82.2219 78.5037H87.4666L75.1616 106.745H69.9975L57.6521 78.5037H63.3407L72.7409 100.29Z"
      />
      <path
        className={classes.path}
        d="M39.4166 94.5607V102.347H55.3527V106.745H34.1719V78.5037H54.7879V82.9012H39.4166V90.2439H53.0531V94.5607H39.4166Z"
      />
      <path
        className={classes.path}
        d="M12.3454 106.745H0V78.5037H12.3454C21.5036 78.5037 27.757 84.1519 27.757 92.6242C27.757 101.097 21.5036 106.745 12.3454 106.745ZM5.24478 82.9415V102.307H12.1033C18.3971 102.307 22.4718 98.4742 22.4718 92.6242C22.4718 86.7743 18.3971 82.9415 12.1033 82.9415H5.24478Z"
      />
      <defs>
        <clipPath id="traton-logo-clip">
          <rect
            width="315.191"
            height="68.9217"
            fill="white"
            transform="translate(64.6826)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
